import { Routes } from '@angular/router';
import { ResetPasswordComponent } from './core/component/reset-password/component/reset-password.component';
import { MainLayoutComponent } from './core/component/main-layout/main-layout.component';
import { canActivateGuard } from './core/guards/can-activate.guard';
import { LoginComponent } from './core/component/login/component/login.component';
import { UserTypeScreenComponent } from './core/component/user-type-screen/component/user-type-screen.component';
import { DemoAiServicesModule } from './demo-ai-services/demo.ai.services.module';
import { Error401Component } from './core/error-401/error-401.component';
import { OnlineConsentComponent } from './core/common/public-pages/online-consent/component/online-consent/online-consent.component';
import { InitialAssesmentsComponent } from './care-manager-portal/components/profile-view/component/behaviour/component/monthly-follow-up/component/initial-assesments/initial-assesments.component';
import { MonthlyCarePlanComponent } from './care-manager-portal/components/profile-view/component/behaviour/component/monthly-follow-up/component/monthly-care-plan/monthly-care-plan.component';
import { ProfileViewComponent } from './care-manager-portal/components/profile-view/component/profile-view/profile-view.component';

export const routes: Routes = [
  //{ path: '', redirectTo: 'usertype', pathMatch: 'full' },
{ path: '', component: LoginComponent },
{
  path: 'onlineconsent/:hash',
  loadComponent: () =>
    import('./core/common/public-pages/online-consent/component/online-consent/online-consent.component')
  .then(m => m.OnlineConsentComponent),
  data: { public: true }
}, 
// {
//   path: 'profile-view/:id',
//   loadComponent: () =>
//     import('./care-manager-portal/components/profile-view/component/profile-view/profile-view.component')
//   .then(m => m.ProfileViewComponent),
//   data: { public: true }
// },
{
  path: 'devicesetupguidelines/:patientId',
  loadComponent: () =>
    import(
      './logistic-portal/component/device-setup/component/device-setup-guidelines/device-setup-guidelines.component'
    ).then(m => m.DeviceSetupGuidelinesComponent),
  data: { public: true }
},
{
  path: 'devicesetupscheduling/:patientId',
  loadComponent: () =>
    import(
      './logistic-portal/component/device-setup/component/device-setup-scheduling-screen/device-setup-scheduling-screen.component'
    ).then(m => m.DeviceSetupSchedulingScreenComponent),
  data: { public: true }
},
  {
  path: 'firstchoiceconsentform',
  loadComponent: () =>
    import(
     './patient-on-boarding-portal/components/first-choice-consent/first-choice-consent-form/first-choice-consent-form.component'
    ).then(m => m.FirstChoiceConsentFormComponent),
  data: { public: true }
},
  {path:'usertype',component:UserTypeScreenComponent,canActivate: [canActivateGuard]},
  {path:'resetpassword',component:ResetPasswordComponent},
  {
    path: 'dashboard',
    component: MainLayoutComponent,
    canActivate: [canActivateGuard],
    children: [
      { path: 'admin', loadChildren: () => import('../app/admin-portal/admin-portal.module').then(m => m.AdminPortalModule) },
      { path: 'patient', loadChildren: () => import('../app/patient-portal/patient-portal.module').then(m => m.PatientPortalModule) },
      { path: 'patientonboarding', loadChildren: () => import('../app/patient-on-boarding-portal/patient-on-boarding-portal.module').then(m => m.PatientOnBoardingPortalModule) },
      { path: 'caremanager', loadChildren: () => import('../app/care-manager-portal/care-manager-portal.module').then(m => m.CareManagerPortalModule) },
      { path: 'doctor', loadChildren: () => import('../app/doctor-portal/doctor-portal.module').then(m => m.DoctorPortalModule) },
      { path: 'reporting', loadChildren: () => import('../app/reporting-portal/reporting-portal.module').then(m => m.ReportingPortalModule) },
      { path: 'microservice', loadChildren: () => import('../app/micro-service-portal/micro-service-portal.module').then(m => m.MicroServicePortalModule) },
      { path: 'ai', loadChildren: () => import('../app/demo-ai-services/demo.ai.services.module').then(m => m.DemoAiServicesModule) },
      { path: 'logistic', loadChildren: () => import('../app/logistic-portal/logistic-portal.module').then(m=> m.LogisticPortalModule) },      
      { path: 'sdoh', loadChildren: () => import('../app/sdoh-portal/sdoh-portal.module').then(m => m.SDOHPortalModule) },
      { path: 'billing', loadChildren: () => import('../app/billing-portal/billing-portal.module').then(m => m.BillingPortalModule) },
      { path: 'populationhealth', loadChildren: () => import('../app/population-health-portal/population-health-portal.module').then(m => m.PopulationHealthPortalModule) },
      { path: 'analysis', loadChildren: () => import('../app/analysis-dashboard-portal/analysis-dashboard-portal.module').then(m => m.AnalysisDashboardPortalModule) },
    ]
  },
  { path: '401', component: Error401Component },
  { path: '**', redirectTo: '', pathMatch: 'full' }, // ✅ Prevents unnecessary redirections

];